export var default_lastReadMessageSequence = 0;
export var default_lastSeenMessageSequence = 0;
export var default_unreadCount = 0;
export var default_siteUserType = 'Visitor';
